import request from '@/api/clients/portal-client'

// 用户登录
export function login(data) {
  return request({
    url: '/base/user/login',
    method: 'post',
    data: {
      email: data.identifier || data.email || data.phone,
      password: data.password
    }
  })
}

// 用户注册
export function register(data) {
  return request({
    url: '/base/user/userRegister',
    method: 'post',
    data
  })
}

// 手机号注册
export function registerByPhone(data) {
  return request({
    url: '/base/user/userRegisterByPhone',
    method: 'post',
    params: {
      phone: data.phone,
      password: data.password,
      confirmPassword: data.confirmPassword,
      verificationCode: data.verificationCode,
      inviteCode: data.inviteCode
    }
  })
}

// 忘记密码
export function forgetPassword(data) {
  return request({
    url: '/base/user/forget',
    method: 'post',
    params: {
      phone: data.phone,
      password: data.password,
      confirmPassword: data.confirmPassword,
      verificationCode: data.verificationCode
    }
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/base/user/userInfo',
    method: 'post'
  })
}

// 更新用户信息
export function updateUserInfo(data) {
  return request({
    url: '/base/user/updateUserInfo',
    method: 'post',
    data
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/base/user/modPassword',
    method: 'post',
    data
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/base/user/logout',
    method: 'post'
  })
}

// 发送验证码
export function sendVerificationCode(phone) {
  return request({
    url: '/sms/sendCodeByTencent',
    method: 'post',
    data: { mobile: phone }
  })
}

// 获取用户文件夹列表
export function getUserFolderList() {
  return request({
    url: '/userfolder/list',
    method: 'get'
  })
}

// 获取用户缺省文件夹对象
export function getUserDalFolder() {
  return request({
    url: '/userfolder/getUserDalFolder',
    method: 'get'
  })
}

// 添加用户文件夹
export function addUserFolder(data) {
  return request({
    url: '/userfolder/add',
    method: 'post',
    data
  })
}

// 删除用户文件夹
export function deleteUserFolder(id) {
  return request({
    url: '/userfolder/delete',
    method: 'post',
    data: { id }
  })
}

// 获取文件夹下文件列表
export function getFilesByFolder(folderId, page, limit, fileType) {
  const params = { folderId }
  
  // 如果提供了分页参数，则添加到请求参数中
  if (page !== undefined && page !== null) {
    params.page = page
  }
  if (limit !== undefined && limit !== null) {
    params.limit = limit
  }
  // 文件类型筛选：all 表示不筛选
  if (fileType && fileType !== 'all') {
    params.fileType = fileType
  }
  
  return request({
    url: '/userfolder/files',
    method: 'post',
    params: params
  })
}

// 删除单个文件
export function deleteUserFile(fileId) {
  return request({
    url: '/userfolder/file/delete',
    method: 'post',
    data: { fileId }
  })
}

// 重命名文件
export function renameUserFile(fileId, newName) {
  return request({
    url: '/userfolder/file/rename',
    method: 'post',
    data: { fileId, newName }
  })
}

// 移动文件到指定文件夹
export function moveUserFile(fileId, folderId) {
  return request({
    url: '/userfolder/file/move',
    method: 'post',
    data: { fileId, folderId }
  })
}

// 批量移动文件到指定文件夹
export function batchMoveUserFiles(fileIds, targetFolderId) {
  return request({
    url: '/userfolder/file/batchMove',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ fileIds, targetFolderId })
  })
}

// 批量删除文件
export function batchDeleteUserFiles(fileIds) {
  return request({
    url: '/userfolder/file/batchDelete',
    method: 'post',
    headers: {
      'Content-Type': 'application/json' // 添加JSON内容类型头
    },
    data: JSON.stringify(fileIds) // 直接传递数组
  })
}

// 批量下载文件（返回url列表）
export function batchDownloadUserFiles(fileIds) {
  return request({
    url: '/userfolder/file/batchDownload',
    method: 'post',
    headers: {
      'Content-Type': 'application/json' // 添加JSON内容类型头
    },
    data: JSON.stringify(fileIds) // 直接传递数组
  })
}

// 单个文件下载（返回url）
export function downloadUserFile(fileId) {
  return request({
    url: '/userfolder/file/download',
    method: 'get',
    params: { fileId }
  })
}

// 上传文件到指定文件夹
export function uploadUserFile(formData) {
  return request({
    url: '/ksai/upload',
    method: 'post',
    data: formData,
    timeout: 600000, // 设置超时时间为10分钟
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 修改文件夹名称
export function renameUserFolder(folderId, newName) {
  return request({
    url: '/userfolder/rename',
    method: 'post',
    data: { folderId, newName }
  })
}

// 上传头像
export function updateHeadPortrait(formData) {
  return request({
    url: '/base/user/updateHeadPortrait',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 获取系统TTS模型配置
export function getSysTtsModel() {
  return request({
    url: '/sysconfig/getSysTtsModel',
    method: 'get'
  })
}

// 上传图片
export function uploadImage(formData) {
  return request({
    url: '/base/user/uploanImg',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 保存代理基础信息
export function saveAgentBasicInfo(data) {
  return request({
    url: '/base/user/saveAgentBasicInfo',
    method: 'post',
    data
  })
}

// 根据agentId获取代理信息（不需要登录）
export function getAgentInfoByAgentId(agentId) {
  return request({
    url: '/base/user/getAgentInfoByAgentId',
    method: 'post',
    params: { agentId }
  })
}

// 获取代理邀请码列表
export function getAgentInviteCodeList(params) {
  return request({
    url: '/base/user/getAgentInviteCodeList',
    method: 'post',
    params: params
  })
}

// 更新邀请码备注
export function updateInviteCodeRemark(params) {
  return request({
    url: '/base/user/updateInviteCodeRemark',
    method: 'post',
    params: params
  })
}

// 获取代理算力流水列表
export function getAgentPowerLogList(params) {
  return request({
    url: '/fin/accountlog/agentPowerLogList',
    method: 'post',
    data: params
  })
}

// 获取下级用户列表（包含自己）
export function getSubUserList() {
  return request({
    url: '/base/user/getSubUserList',
    method: 'post'
  })
}

// 转移算力池算力
export function transferPowerPool(params) {
  return request({
    url: '/base/user/transferPowerPool',
    method: 'post',
    data: params
  })
}

// 获取代理汇总数据
export function getAgentSummary() {
  return request({
    url: '/base/user/getAgentSummary',
    method: 'post'
  })
}

// 获取代理商结算对账列表
export function getCreditCalculationList(params) {
  return request({
    url: '/fin/accountlog/creditCalculationList',
    method: 'post',
    data: params
  })
}

// 更新文件sign标识（防止7天自动删除）
export function updateFileSign(fileId, sign) {
  return request({
    url: '/userfolder/file/sign',
    method: 'post',
    data: { fileId, sign }
  })
}
